import {createReducer, on} from "@ngrx/store";
import {DashboardActions} from "../actions";
import {
  ViewDashboardCase,
  ViewDashboardCaseArchived,
  ViewDashboardCaseClosed,
  ViewDashboardCaseIncoming,
  ViewDashboardCaseRegionReport,
  ViewDashboardRegion
} from "@esa/api";
import {PagedResponse} from "../../models/paged-response";

export const dashboardCaseFilesFeatureKey = 'dashboardCaseFiles';

export interface DashboardCaseFilesState {
  incomingDashCaseFiles: ViewDashboardCaseIncoming[];
  incomingPagedResponse: PagedResponse;
  outgoingDashCaseFiles: ViewDashboardCaseIncoming[];
  outgoingPagedResponse: PagedResponse;
  archivedCaseFiles: ViewDashboardCaseArchived[];
  closedCaseFiles: ViewDashboardCaseClosed[];
  closedPagedResponse: PagedResponse;
  archivedPagedResponse: PagedResponse;
  activeCaseFiles: ViewDashboardCase[];
  activePagedResponse: PagedResponse;
  regionCases: ViewDashboardRegion[];
  regionReport: ViewDashboardCaseRegionReport[];
}

const initialState: DashboardCaseFilesState = {
  incomingDashCaseFiles: [],
  incomingPagedResponse: {
    totalCount: 0,
    pagedCount: 0
  },
  outgoingDashCaseFiles: [],
  outgoingPagedResponse: {
    totalCount: 0,
    pagedCount: 0
  },
  archivedCaseFiles: [],
  archivedPagedResponse: {
    totalCount: 0,
    pagedCount: 0
  },
  activeCaseFiles: [],
  activePagedResponse: {
    totalCount: 0,
    pagedCount: 0
  },
  closedCaseFiles: [],
  closedPagedResponse: {
    totalCount: 0,
    pagedCount: 0
  },
  regionCases: [],
  regionReport: []
};

export const dashboardCaseFilesReducer = createReducer(
  initialState,
  on(DashboardActions.getIncomingDashCaseSuccess, (state, { incomingDashCaseFiles, incomingPagedResponse }) => ({ ...state, incomingDashCaseFiles, incomingPagedResponse })),
  on(DashboardActions.getOutgoingDashCaseSuccess, (state, { outgoingDashCaseFiles, outgoingPagedResponse }) => ({ ...state, outgoingDashCaseFiles, outgoingPagedResponse })),
  on(DashboardActions.getArchivedDashCaseSuccess, (state, { archivedCaseFiles, archivedPagedResponse }) => ({ ...state, archivedCaseFiles, archivedPagedResponse })),
  on(DashboardActions.getActiveDashCaseSuccess, (state, { activeCaseFiles, activePagedResponse }) => ({ ...state, activeCaseFiles, activePagedResponse })),
  on(DashboardActions.getClosedDashCaseSuccess, (state, { closedCaseFiles, closedPagedResponse }) => ({ ...state, closedCaseFiles, closedPagedResponse })),
  on(DashboardActions.getRegionCasesSuccess, (state, { regionCases }) => ({ ...state, regionCases })),
  on(DashboardActions.getRegionReportSuccess, (state, { regionReport }) => ({ ...state, regionReport: regionReport }))
);
